import Icon from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Play from '@/assets/icons/play-1.svg?react';
import styles from './details-link.module.scss';

interface DetailsLinkProps {
  link: string;
}

export const DetailsLink = ({ link }: DetailsLinkProps) => {
  const { t } = useTranslation('common');

  return (
    <Link to={link} className={styles.link}>
      <span className={styles.linkText}>{t('actions.details')}</span>
      <Icon
        className={styles.playIcon}
        component={() => <Play stroke={styles.playIcon} width={9} height={9} />}
      />
    </Link>
  );
};
